import { IExpense } from "src/domain/entities"
import { expenseListApi } from "../../api/expense/expenseListApi"

type PayloadShape = Parameters<typeof expenseListApi>[0]

export async function expenseListService(payload: PayloadShape, token?: null | string) {
	const expense = await expenseListApi(payload, token)
	return expense as NonNullable<IExpense[]>
}
